/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FadeInAnimation } from '../shared';
import { parseTitle } from '../../../utils/title-parser';
import Image from '../shared/image.component';

import { useCitiesData } from '../../domain/city/city.domain';


const CityMainSection = (props) => {

    const { cityName, data } = props;    

    const { data: cities } = useCitiesData(); 

    const city = _.find(data, (detail) => _.trim(detail.city_name.replace(/_/g, '')) === cityName);

    const cityAPI = _.find(cities, (c) => c.name === cityName);

    return (
        <>
        
            <div className='container-root container-root-maxWidthLg'>

                <div className='play-page-city-main-section-header-container'>
                    {parseTitle(_.get(city, 'city_name'), 'city_details_header')}
                </div>

                <FadeInAnimation>
                    <div>
                        <p className='play-page-city-main-section-paragraph'>
                            {_.get(city, 'city_details')}
                        </p>
                    </div>
                </FadeInAnimation>

            </div>

            <Image
                src={_.get(cityAPI, 'images[0]')}
                alt={_.get(cityAPI, 'name')}
                className="play-page-city-main-section-image card-image"
                isOldImage
            />

        </>
    );
};

export default CityMainSection;

CityMainSection.propTypes = {
    cityName: PropTypes.string,    
    data: PropTypes.array,
    cities: PropTypes.array,
};

